<template>
  <div class="page_title">
    <div class="breadcrumbs">
      <template :key="index" v-for="(item, index) in props.list">
        <div :class="{ breadcrumb: true, active: item.isActive }" @click="menuClick(item)">
          {{ item.name }}
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance } from 'vue'
const { proxy } = getCurrentInstance()
const props = defineProps({
  list: {
    type: Array,
    default: () => {
      return []
    }
  }
})
const menuClick = item => {
  if (item.path) {
    proxy.$router.push(item.path)
  }
}
</script>

<style lang="less" scoped>
.page_title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: left;
  padding-top: 0px;
  padding: 0px 0px 17px 0px;
  box-sizing: content-box;
  .breadcrumbs {
    font-size: 22px;
    cursor: pointer;
    color: #00000033;
    font-weight: bold;
    align-items: center;
    display: inline-flex;
    justify-content: flex-start;
    .active {
      color: black;
    }
    .breadcrumb:last-child::after {
      content: '';
    }
    .breadcrumb::after {
      content: '/';
      display: inline-block;
      margin: 0 0.3em;
    }
  }
}
</style>
